import { IntakeForm } from '@app/components/intake/form'
import type { IRoute } from '@app/layouts/intake'

export const routes: IRoute[] = [
  {
    component: IntakeForm,
    exact: true,
    label: 'Intake',
    path: '/intake/new',
    title: 'Intake',
  },
]
